import React, { FunctionComponent } from 'react';
import usePlatformConfig from '../../react/usePlatformConfig';
import dealPriceAccessor from '../../service/dealPriceAccessor';
import OptionPriceSingleCurrency from '../../../customise/components/presentational/prices/singleCurrency/optionPrice/OptionPriceSingleCurrency';
import { IPrices } from '../../../../../common/model/IPrice';
import OptionPriceMultiCurrency from '../../../customise/components/presentational/prices/multiCurrency/optionPrice/OptionPriceMultiCurrency';

export interface IConfigurablePriceProps {
  prices: IPrices;
  display?: {
    optionPriceLabel?: boolean;
    showOrLabel?: boolean;
  };
  classes?: {
    single?: {
      priceText: string | undefined;
    };
    multi?: {
      container?: string | undefined;
      priceText: string | undefined;
    };
  };
}

const ConfigurablePrice: FunctionComponent<IConfigurablePriceProps> = ({ prices, display, classes }) => {
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();
  const isMultiCurrency = dealPriceAccessor.isMultiCurrency(priceDisplay);

  if (!isMultiCurrency) {
    return (
      <OptionPriceSingleCurrency
        classes={{ priceText: classes?.single?.priceText }}
        prices={prices}
        display={{ optionPriceLabel: display?.optionPriceLabel ?? false }}
      />
    );
  }

  return (
    <OptionPriceMultiCurrency
      prices={prices}
      showOrLabel={display?.showOrLabel}
      classes={{
        container: classes?.multi?.container,
        priceText: classes?.multi?.priceText,
      }}
    />
  );
};

export default ConfigurablePrice;
